import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import { Dialog } from '@material-ui/core';
import { AppTheme } from '../../styles/AppTheme';
import { AppButton } from './AppButton';
import { ApiHelper } from '../helpers/ApiHelper';
import { Helper } from '../helpers/Helper';
import { UiHelper } from '../helpers/UiHelper';

export class DeleteModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteState: null
    }
  }
  onDeleteAd = async () => {
    this.setState({
      deleteState: ApiHelper.State.LOADING
    })
    try {
      const ApiOptions = {
        method: this.props.apiMethod,
        endPoint: this.props.apiEndPoint
      }
      const response = await ApiHelper.callAwait(ApiOptions)
      this.setState({
        deleteState: ApiHelper.State.READY,
        errMsg: null,
      })
      this.props.onDeleteAdComplete()
    } catch (e) {
      console.log('err', e)
      this.setState({
        deleteState: ApiHelper.State.ERROR,
        errMsg: Helper.getErrorMsg(e),
      })
    }

  }

  render() {
    return (
      <Dialog open={this.props.open}
        classes={{
          root: css(Styles.customRoot),
          paper: css(Styles.customPaper),
        }}>
        <button className={css(Styles.modalCloseButton)} onClick={this.props.onCancel}
          disabled={this.state.deleteState === ApiHelper.State.LOADING ? true : false}>
          {UiHelper.renderImg({key:'dialogCloseIcon'})}
        </button>
        <div className={css(Styles.container)}>
          <p className={css(Styles.deleteTitleText)}>Delete Ad</p>
          <p className={css(Styles.message)}>Your file will be deleted permanently. Are you sure ?</p>
          {this.state.errMsg && <p className={css(Styles.errorTextMobileView)}>{this.state.errMsg}</p>}
          <div className={css(Styles.actions)}>
            {this.state.errMsg && <p className={css(Styles.errorText)}>{this.state.errMsg}</p>}
            <AppButton buttonText='Cancel' onClick={this.props.onCancel}
              disabled={this.state.deleteState === ApiHelper.State.LOADING ? true : false} />
            <AppButton buttonText='Delete'
              buttonStyle={Styles.deleteButtonStyle}
              inProcess={this.state.deleteState === ApiHelper.State.LOADING ? true : false}
              onClick={this.onDeleteAd} />
          </div>
        </div>
      </Dialog >
    );
  }
}

const Styles = StyleSheet.create({

  container: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'center',
    backgroundColor: 'whitesmoke',
    minWidth: 400,
    // minHeight: 300,
    padding: 20,
    '@media (max-width: 767px)': {
      minWidth: 200,
    }
  },
  actions: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    // alignItems: 'flex-end',
    justifyContent: 'flex-end',
    '@media (max-width: 767px)': {
      justifyContent: 'center',
    }
  },
  confirmation: {
    fontSize: 12,
    textAlign: 'center',
    margin: 5
  },
  message: {
    fontSize: 20,
    textAlign: 'center',
    margin: 30,
    '@media (max-width: 767px)': {
      margin: 15,
      fontSize: 16,
    }
  },
  button: {
    margin: 10,
    cursor: 'pointer',
    minWidth: 80
  },
  customRoot: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    backdropFilter: 'blur(10px)',
    zIndex: 13000
  },
  customPaper: {
    borderRadius: 16,
    // minWidth: 600,
    backgroundColor: AppTheme.secondaryBg,
    '::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 767px)': {
      borderRadius: 20,
    },
  },
  deleteButtonStyle: {
    background: '#FF0D0D !important',
    marginLeft: 10
  },
  deleteTitleText: {
    fontSize: 26,
    fontWeight: 'bold',
    color: '#000000',
    margin: 0
  },
  errorText: {
    color: '#FF0D0D',
    fontSize: 18,
    margin: 0,
    '@media (max-width: 767px)': {
      display: 'none'
    }
  },
  errorTextMobileView: {
    display: 'none',
    '@media (max-width: 767px)': {
      display: 'unset',
      color: '#FF0D0D',
      fontSize: 14,
      margin: 0,
      marginBottom: 10
    }
  },
  modalCloseButton: {
    position: 'absolute',
    top: 25,
    right: 30,
    border: 'none',
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
    // '@media (max-width: 767px)': {
    //   top: 15,
    //   right: 20,
    // },
  },
  modalCloseIcon: {
    width: 18,
    height: 18
  },
})


// WEBPACK FOOTER //
// ./src/common/components/DeleteModal.js